import { render, staticRenderFns } from "./JsonView.vue?vue&type=template&id=1f9a7bbb&scoped=true&"
import script from "./JsonView.vue?vue&type=script&lang=js&"
export * from "./JsonView.vue?vue&type=script&lang=js&"
import style0 from "./JsonView.vue?vue&type=style&index=0&id=1f9a7bbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a7bbb",
  null
  
)

export default component.exports